import { Component } from '@angular/core';

@Component({
    selector: 'app-processbar',
    templateUrl: './processbar.component.html',
    styleUrls: ['./processbar.component.scss'],
    standalone: false,
})
export class ProcessbarComponent {}
